import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import {
  ModuleDoneType,
  ModuleType,
  PlanQuestionType,
  PlanType,
} from "../../templates/types";

export const QuickstartLocationsTemplate: PlaniraTemplate = {
  planType: PlanType.Quickstart,
  type: PlanTemplateType.QuickstartLocations,
  title: "Find locations",
  description:
    "Add and discuss your favorite spots, then vote to choose the group's top pick.",
  longDescription: "",
  emoji: "🌎",
  titleHelp: "Where to go, host a party, best fishing spot",
  image: require("../../assets/illustrations/Travelers-bro.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Find locations",
          isDraggable: false,
          emoji: "🌎",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Location,
          doneType: ModuleDoneType.Voting,
          title: "Location",
          emoji: "🌎",
          questionOption: {
            question: "Do you know where you're going?",
            questionType: PlanQuestionType.Location,
          },
        },
      ],
    },
  ],
};
